class RecentArticleSearch extends HTMLElement {
    constructor(){
        super()

        const recentSearchArticleContainer = document.querySelector('.recent-search__articles')

        this.query = localStorage.getItem('recentArticleSearch') || undefined
        if(this.query){
            this.fetchRecentlySearchedArticles()
            recentSearchArticleContainer.classList.remove('hide-title')
        } else {
            recentSearchArticleContainer.classList.add('hide-title')
        }
    }

    // Get recently searched articles
    async fetchRecentlySearchedArticles(){
        let html = await fetch(`/search?q=${this.query}&view=article&type=article`).then((res)=>
                res.text()
            ).then((data)=> {
                return data
            })

        let parser = new DOMParser()
        let dom = parser.parseFromString(html,"text/html")

        if(dom.querySelectorAll('.articles-card_wrapper').length > 0){
            this.querySelector('#recent_seach_results').innerHTML = dom.querySelector('body').innerHTML
            this.initSlickSlider()
        } 
    }

    initSlickSlider(){

        let slider = this.querySelector('.blog-featured')

        new Splide(this.querySelector('.blog-featured-search'), {
            type: 'slide',
            speed: 500,
            pagination: false,
            arrows: true,
            padding: '17px',
            perPage: 4,
            perMove: 1,
            breakpoints: {
                1100: {
                    perPage: 3,
                    perMove: 1,
                    padding: '17px',
                },
                990: {
                    perPage: 2.5,
                    perMove: 1,
                    padding: '17px',
                },
                480: {
                    perPage: 1.74,
                    padding: '10px',
                    perMove: 1
                }
            }
        }).mount();
    }
}

customElements.define('recent-search-articles',RecentArticleSearch)